import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { SearchOutlined, WarningFilled } from '@ant-design/icons'
import { Col, Row, Input, Tabs, Badge } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { RootState } from 'Store'
import { CountReq, GrnImproveListReq, GrnListReq } from 'Store/grn/types'
import { getCountAPI, grnImproveListAPI, grnListAPI } from 'Store/grn/api'
import { selectCountData, selectGrnActionEvent } from 'Store/grn/selector'
import { selectCurrentUser } from 'Store/user/selector'
import { getDateFromNow, getSupplierMenuSelect } from 'helpers/format'
import { GrnStatus, menuGrnStatus } from 'helpers/constanst'
import { PrimaryButton } from 'Components/button'
import HomePageLayout from 'Pages/Layout/PageLayout'
import { SelectItem } from 'Components/form'
import { SupplierListReq } from 'Store/supplier/types'
import { allSupplierListAPI } from 'Store/supplier/api'
import PayDept from './paydept'
import theme from 'Components/common/Theme'
import { selectAllSupplierList } from 'Store/supplier/selector'
import GrnTable from './components/GrnTable'
import PaymentDetail from './payment_detail'
import { selectLastCreateID } from 'Store/grn-payment/selector'
import { AppTutorial } from 'Components/utilities'
import { TutorialGrnPage, TutorialPurchasePage } from 'helpers/tutorials'

const { TabPane } = Tabs

type Props = {} & ReduxProps

const GrnPage: React.FunctionComponent<Props> = props => {
  const { currentUser, supplierList, lastCreateGrnID, countData } = props
  const dispatch = useDispatch()
  const [payDeptDrawer, setPayDeptDrawer] = useState(false)
  const [activeStatus, setActiveStatus] = useState(GrnStatus.EXPIRED as string)
  const [paymentDrawer, setPaymentDrawer] = useState(false)

  // tutorial
  const [showTutorial, setShowTutorial] = useState(false as boolean)
  const steps = TutorialGrnPage.list.steps
  const enableTutorial = TutorialGrnPage.list.enable

  const [filter, setFilter] = useState({
    keyword: '',
    status: '',
    start_date: '',
    end_date: '',
    supplier_id: 0,
    order_by: 'grn_id',
    sort: 'desc',
  })
  const [pagination, setPagination] = useState({
    Page: 1,
    RowPerPage: 10,
  })

  const onGetList = (): void => {
    // if (activeStatus === GrnStatus.SUCCESS) {
    //   onGetPaymentList()
    // } else {
    //   onGetGrnList()
    // }
    onGetGrnList()
  }

  const onGetGrnList = (): void => {
    const req: GrnImproveListReq = {
      keyword: filter.keyword,
      page: pagination.Page,
      per_page: pagination.RowPerPage,
      supplier_id: filter?.supplier_id,
      order_by: filter.order_by || 'grn_id',
      sort: filter.sort || 'desc',
    }

    if (filter?.supplier_id && filter.supplier_id > 0) {
      req['supplier_id'] = filter?.supplier_id
    }

    if (activeStatus) {
      req['status'] = activeStatus
    }

    if (activeStatus === GrnStatus.EXPIRED) {
      req['payment_date_to'] = getDateFromNow(3)
      req['status'] = GrnStatus.PENDING
    }

    dispatch(grnImproveListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  const onGetSupplierList = (): void => {
    const req: SupplierListReq = {
      merchant_id: currentUser?.activeMerchant?.id || 0,
      all: true,
    }
    dispatch(allSupplierListAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || ''))
  }

  const onCount = (): void => {
    const req: CountReq = {}
    dispatch(getCountAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.id || 0))
  }

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetList()
    }
  }, [pagination])

  useEffect(() => {
    if (currentUser?.accessToken) {
      onGetSupplierList()
      onCount()
    }
  }, [])

  const onClickSearch = () => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  useEffect(() => {
    if (pagination.Page === 1) return
    pagination.Page = 1
    pagination.RowPerPage = 10
    setPagination({ ...pagination })
  }, [])

  const onFilter = (key: string, val: string) => {
    setFilter({
      ...filter,
      [key]: val,
    })
  }

  const onSort = (order_by: string, sort: string) => {
    setFilter({
      ...filter,
      sort,
      order_by,
    })
  }

  useEffect(() => {
    pagination.Page = 1
    setPagination({ ...pagination })
  }, [filter?.order_by, filter?.sort])

  const onPaydeptSuccess = () => {
    setPayDeptDrawer(false)
    onGetList()
    setPaymentDrawer(true)
    onCount()
  }

  const PayDeptlDrawer = (
    <PayDept
      visible={payDeptDrawer}
      onCloseDrawer={() => setPayDeptDrawer(false)}
      onSuccess={onPaydeptSuccess}
    />
  )

  const FilterContent = (
    <FilterWrapper>
      <Row justify="space-between" align="bottom">
        <MyCol xs={24} md={18} className="ttr-filter">
          <Row gutter={[8, 8]}>
            <Col xs={24} md={10}>
              <SearchInput
                placeholder="ค้นหาเลขที่ใบสั่งซื้อ, GRN, ใบรับสินค้า"
                prefix={<SearchOutlined />}
                allowClear
                value={filter.keyword}
                onChange={(evt: any): void => onFilter('keyword', evt.target.value)}
              />
            </Col>
            <Col xs={24} md={10}>
              <SelectItem
                name="supplier_id"
                label="เลือกบริษัท/Supplier ที่ต้องการจ่ายหนี้"
                placeHolder="เลือกบริษัท/Supplier"
                isRequired={true}
                value={filter.supplier_id}
                onChange={(val: any): any => onFilter('supplier_id', val)}
                menu={getSupplierMenuSelect(supplierList, 'name', 'id')}
                allowClear={true}
              />
            </Col>
            <Col>
              <PrimaryButton text="ค้นหา" btnType="Cancel" onClick={onClickSearch} />
            </Col>
          </Row>
        </MyCol>
        <MyCol className="ttr-pay-all">
          <PrimaryButton text="จ่ายหนี้หลายรายการ" btnType="Primary" onClick={() => setPayDeptDrawer(true)} />
        </MyCol>
      </Row>
    </FilterWrapper>
  )

  const onChangeTab = (key: string) => {
    setActiveStatus(key)
    pagination.Page = 1
    setPagination({ ...pagination })
  }

  const renderTitle = (name: string, key: string) => {
    const newcountData = countData as any
    const count = newcountData?.[key || 'all'] || 0
    return (
      <span>
        {name} <Badge count={count} showZero={false} overflowCount={9999} />
      </span>
    )
  }

  const getTab = () => {
    return (
      <Tabs onChange={onChangeTab} activeKey={activeStatus} type="line" className="ttr-status">
        {menuGrnStatus.map((item: any) => {
          return <TabPane tab={renderTitle(item.name, item.value)} key={item.value}></TabPane>
        })}
      </Tabs>
    )
  }

  const DetailDrawer = (
    <PaymentDetail
      id={lastCreateGrnID}
      visible={paymentDrawer}
      onCloseDrawer={() => setPaymentDrawer(false)}
      onSuccess={() => {}}
    />
  )

  return (
    <>
      <HomePageLayout
        selected="grn"
        title="รายการจ่ายหนี้"
        label=""
        isShowTutorial={showTutorial}
        showTutorial={enableTutorial}
        onClickStart={() => setShowTutorial(true)}
      >
        {getTab()}
        {FilterContent}
        {/* {activeStatus == GrnStatus.SUCCESS ? (
          <PaymentSuccessTable
            onGetList={onGetPaymentList}
            setPagination={setPagination}
            pagination={pagination}
          />
        ) : (
          <GrnTable
            onGetList={onGetGrnList}
            setPagination={setPagination}
            pagination={pagination}
            onPaymentSuccess={onPaydeptSuccess}
            isPatial={activeStatus === GrnStatus.PATIAL}
          />
        )} */}
        <div className="ttr-datas">
          <GrnTable
            onGetList={onGetGrnList}
            setPagination={setPagination}
            pagination={pagination}
            onPaymentSuccess={onPaydeptSuccess}
            isPatial={activeStatus === GrnStatus.PATIAL}
            isSuccess={activeStatus === GrnStatus.SUCCESS}
            onSort={onSort}
          />
        </div>
        {PayDeptlDrawer}
        {DetailDrawer}
        {enableTutorial && (
          <AppTutorial
            onCloaseTutorial={() => setShowTutorial(false)}
            showTutorial={showTutorial}
            steps={steps}
          />
        )}
      </HomePageLayout>
    </>
  )
}

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectGrnActionEvent(state),
    supplierList: selectAllSupplierList(state),
    lastCreateGrnID: selectLastCreateID(state),
    countData: selectCountData(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

const FilterWrapper = styled.div`
  padding: 10px 0 5px 0;
`

const MyCol = styled(Col)`
  margin-top: 10px;
`

const SearchInput = styled(Input)`
  border-radius: 6px;
  height: 45px;
`

export default connect(mapStateToProps)(GrnPage)
